import { Text } from '@bizzabo/design-system';
import { makeStyles } from '@material-ui/styles';
import CardMessageWrapper from '../CardMessageWrapper';

interface CardMessageProps {
    emoji?: string;
    text?: string;
}

const CardMessage: React.FC<CardMessageProps> = ({ emoji, text }) => {
    const classes = useStyles();

    return (
        <CardMessageWrapper>
            <div className={classes.cardMessage}>
                <span className={classes.emoji}>{emoji}</span>
                <Text
                    variant="t81"
                    className={classes.textCard}
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                />
            </div>
        </CardMessageWrapper>
    );
};

const useStyles = makeStyles(
    theme => ({
        cardMessage: {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
        },
        emoji: {
            fontSize: '2rem',
        },
        textCard: {
            textAlign: 'center',
            marginTop: 10,
            color: theme.palette.greys[600],
        },
    }),
    { classNamePrefix: CardMessage.name }
);

export default CardMessage;
